import React, { FunctionComponent } from 'react';

import styled from 'styled-components';

import Box from '@components/layout/box';
import Typography from '@components/basics/typography';
import CircleRightArrowIcon from '@components/basics/icons/circle-right-arrow';
import { Translate } from 'react-localize-redux';
import { rgba } from 'polished';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'connected-react-router';
import { CreateOrder } from '@webapp/store/orders/action-creators';
import AppState from '@webapp/store/state';
import { getTracProPlan } from '../../../store/products/selectors';

interface EarningsDeductionBoxProps {
  className?: string;
  text: string;
  total: string;
}

const EarningsDeductionBox: FunctionComponent<EarningsDeductionBoxProps> = ({
  className,
  children,
  text,
  total,
}) => {
  const dispatch = useDispatch();

  const tracPro = useSelector(getTracProPlan);
  const clientId = useSelector((state: AppState) => state.artist.active?.id);
  const id = useSelector(
    (state: AppState) =>
      state.subscriptionManager.summary?.artists
        .find((artist) => artist.id === clientId)
        ?.subscriptions.find(
          (subscription) => subscription.type === 'distribution'
        )?.id
  );

  const handleClick = () => {
    if (tracPro) {
      dispatch(
        new CreateOrder({
          product: tracPro,
          price: tracPro.prices.find((price) => price.frequency === 'year')!,
          quantity: 1,
        })
      );
    }
    return dispatch(push(`/payment/${clientId}/${id || ''}`));
  };

  return (
    <Wrapper className={className || ''} onClick={handleClick}>
      <Text>
        <Translate
          id={text}
          data={{
            amount: total,
          }}
        />
      </Text>
      <CircleRightArrowIcon className="arrow-icon" />
      {children}
    </Wrapper>
  );
};

export default styled(EarningsDeductionBox)`
  height: max-content;
`;

const Wrapper = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  margin-top: 16px;
  background-color: ${({ theme }) => rgba(theme.colors.blueColor, 0.2)};
  cursor: pointer;

  .arrow-icon {
    flex-shrink: 0;
  }
`;

const Text = styled(Typography)`
  font-size: 700;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.black};
  margin-right: 16px;
`;
